'use strict';

/** @ContourPreviewStore */
const ContourPreviewStoreModule = function ContourPreviewStoreModule (APP_DISPATCHER_ID, ContourPreviewActions, Flux, IdentityService, ResourceHelper) {
    //Store init
  const ContourPreviewStore = Flux.Store.create({
    name: 'ContourPreviewStore',
    events: {
      Changed: true,
      RequestCompleted: true,
      RequestFailed: true
    }
  });

  //Null initial state
  ContourPreviewStore.$state = {
    dialogVisibility: false
  };

  const ContourResource = ResourceHelper.getResource('DataExport');

  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  ContourPreviewStore.init = () => {
    const dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);

    dispatcher.register(ContourPreviewActions.ShowContourPreview, this._handleShowContourPreview.bind(this));
    dispatcher.register(ContourPreviewActions.ExportContour, this._handleExportContour.bind(this));
  };

  // Handlers //////////////////////////////////////////////////////////////////

  /**
   * Handles the visibility flag to show/hide the modal
   * Broken into two methods because when clearing the notification, the controller was reading this value and opening the modal again
   */
  this._handleShowContourPreview = () => {
    ContourPreviewStore.$set('dialogVisibility', true);
    ContourPreviewStore.emit(ContourPreviewStore.Events.Changed);
  };

  this._handleExportContour = (data) => {
    ContourResource.create(data.payload)
    .then((dataExport) => {
      syncSubscribe(dataExport);
    })
    .catch(() => {
      ContourPreviewStore.emit(ContourPreviewStore.Events.RequestFailed);
    });
  };

  const syncSubscribe = (dataExport) => {
    if (dataExport.location) {
      ContourPreviewStore.emit(ContourPreviewStore.Events.RequestCompleted, {data: dataExport});
    }
    else {
      const SyncStore = Flux.Store.get('SyncStore');
      SyncStore.subscribe(dataExport.subKey, dataExport.subChannel, {
        message: (msg) => {
          switch (msg.status) {
          case 'complete':
            ContourPreviewStore.emit(ContourPreviewStore.Events.RequestCompleted, JSON.parse(msg.data));
            break;
          case 'error':
            ContourPreviewStore.emit(ContourPreviewStore.Events.RequestFailed);
            break;
          }
        }
      });
    }
  };

  return ContourPreviewStore;
};

ContourPreviewStoreModule.$inject = ['APP_DISPATCHER_ID', 'ContourPreviewActions', 'sbFlux', 'IdentityService', 'ResourceHelper'];

module.exports = ContourPreviewStoreModule;



// WEBPACK FOOTER //
// ./src/app/shared/contourPreview/ContourPreviewStore.js